/**
 * Context to be used for ToastNotifications
 */
import * as React from "react"

type ContextProps = {
  setToastMap: React.Dispatch<React.SetStateAction<Map<string, JSX.Element>>>
}

const initContext: ContextProps = { setToastMap: () => {} }
const ToastContext = React.createContext<ContextProps>(initContext)

export default ToastContext
